import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_CONFIG } from '../app-config';
import { IModelRepository } from './Imodel.repository';
import { ApiResponse, RayModel, TemplateModelViewModel } from './models';


@Injectable({ providedIn: 'root' })
export class ModelRepository implements IModelRepository {

	private readonly httpClient = inject(HttpClient);
	private readonly config = inject(APP_CONFIG);


	getTemplateModel(caseId: string, userId: string): Observable<ApiResponse<TemplateModelViewModel>> {
		const params = new HttpParams().set('caseId', caseId).set('userId', userId);
		return this.httpClient.get<ApiResponse<TemplateModelViewModel>>(this.config.domainTemplatesAPI + '/api/model/get', { params });
	}

	getRayModel(caseId: string, userId: string): Observable<ApiResponse<RayModel>> {
		const params = new HttpParams().set('caseId', caseId).set('userId', userId);
		return this.httpClient.get<ApiResponse<RayModel>>(this.config.domainRayAPI + '/api/model/get', { params });
	}

	saveModel(model: TemplateModelViewModel): Observable<ApiResponse<void>> {
		return this.httpClient.post<ApiResponse<void>>(this.config.domainTemplatesAPI + '/api/model/save', model);
	}

}
